import { TFunction } from 'i18next';

import {
  DeletePermissionErrorCode,
  DeletePermissionErrorCodeTranslationKeyMap,
  ReactivatePermissionErrorCode,
  ReactivatePermissionErrorCodeTranslationKeyMap,
  WithdrawPermissionErrorCode,
  WithdrawPermissionErrorCodeTranslationKeyMap,
} from '../enums/permission-error-code';

// Function to get a generic error message for permission actions
// Returns translated error message as string
const getGenericErrorMessage = (
  action: 'delete' | 'withdraw' | 'reactivate',
  t: TFunction,
): string => {
  return t(`${action}PermissionDialog.errors.failedTo${action[0].toUpperCase() + action.slice(1)}`);
};

// Function to get a specific error message based on the error code for permission actions
// Returns translated error message as string
export const getPermissionErrorMessage = (
  action: 'delete' | 'withdraw' | 'reactivate',
  error: Error,
  t: TFunction,
): string => {
  const errorCode = error.message;

  let errorCodeEnumValues: string[] = [];
  let errorCodeMap: Record<string, string> = {};

  // Determine the error code enum values and translation key map based on the action type
  switch (action) {
    case 'delete':
      errorCodeEnumValues = Object.values(DeletePermissionErrorCode);
      errorCodeMap = DeletePermissionErrorCodeTranslationKeyMap;
      break;
    case 'withdraw':
      errorCodeEnumValues = Object.values(WithdrawPermissionErrorCode);
      errorCodeMap = WithdrawPermissionErrorCodeTranslationKeyMap;
      break;
    case 'reactivate':
      errorCodeEnumValues = Object.values(ReactivatePermissionErrorCode);
      errorCodeMap = ReactivatePermissionErrorCodeTranslationKeyMap;
      break;
  }

  let translatedErrorMessage = '';

  if (errorCodeEnumValues.includes(errorCode)) {
    // It's a known error code, handle it accordingly
    translatedErrorMessage = t(`${action}PermissionDialog.errors.${errorCodeMap[errorCode]}`);
  } else {
    // It's an unknown error code, show generic error message
    translatedErrorMessage = getGenericErrorMessage(action, t);
  }

  return translatedErrorMessage;
};
